/***
 *
 *   TICKET DESCRIPTION STYLES
 *   Lives inside the drawer's scroll, so it grows with its content instead of
 *   being capped.
 *
 **********/

const Style = {
    section: 'border-b border-border bg-surface/40',

    header: `flex w-full items-center gap-2 px-4 py-2.5 text-left transition-colors
        hover:bg-muted/40 focus-visible:outline-none focus-visible:ring-2
        focus-visible:ring-ring focus-visible:ring-inset sm:px-6`,
    chevron: 'shrink-0 text-text-muted transition-transform duration-150',
    chevronClosed: '-rotate-90',
    title: 'text-xs font-semibold uppercase tracking-wide text-text-secondary',
    toggleHint: 'ml-auto text-[11px] text-text-muted',

    body: 'px-4 pb-4 sm:px-6',

    // whitespace-normal: line breaks are already <br /> from formatDescription
    descriptionText: 'max-w-3xl break-words text-sm leading-relaxed text-text-primary',
    descriptionEmpty: 'text-sm italic text-text-muted',
};

export default Style;
